<template>
  <div class="policy-details">
    <div class="policy-title">
      <!--<span>首页 > 隐私政策</span>-->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>隐私政策</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="policy-content">
      <div class="main-content">
        <div class="title-content">
          <div class="details-title">
            <h2>峰学未来用户隐私权保护政策</h2>
          </div>
        </div>
        <div class="details-content">
          <div style="text-align: center;"><strong>引言</strong></div>
          <p>苏州峰学未来教育科技有限公司（以下统称“峰学未来”或“我们”）
            ⾼度重视⼴⼤⽤户的个⼈ 信息安全与隐私保护，我们向⽤户提供⽅便快捷的产品和服务的同时，
            致⼒于提升信息处理的透 明度，增强您对信息管理的便捷性，保障您的信息安全。我们严格遵守法律法规，
            遵循以下隐私 保护原则，以期为您提供更加安全、可靠的产品与服务。</p>
          <p>本政策主要向您阐述我们收集哪些信息、所收集信息的⽤途、您所享有的权利等，并申明了 我们对保护个⼈隐私的承诺。
          <strong>我们未来可能根据信息处理情境的变化更新或修改本政策。
            请您在 使⽤峰学未来提供的任何服务前知晓本政策和任何补充政策，如果您继续使⽤我们的服务即被视 为对新版隐私协议的接受。</strong>
          </p>
          <strong>本政策适⽤于“峰学未来”学习平台产品及服务，
            包括“峰学未来”学习平台官⽹ （fxwljy.com）、“峰学未来”学习平台iOS版软件客户端、“峰学未来”学习平台Android版软件 客户端、
            “峰学未来”学习平台电脑客户端以及您关注或使⽤峰学未来公众号或⼩程序等。</strong>
          <p>本隐私政策旨在向您说明，我们如何收集、使⽤、共享和保护您的个⼈信息及其他相关信 息，请您务必仔细阅读。
          <strong>当您向我们提供您的个⼈信息或开始使⽤我们的产品或服务时，
            即表示 您已知悉并同意我们在本隐私政策中所述内容。
            我们会在以下描述中将重点内容以⽂字加粗的形 式标记，提醒您注意。在使⽤过程中，
            请谨慎考虑是否向我们提供这些信息，我们将尽最⼤努⼒ 保护好您的个⼈信息。</strong>
          </p>
          <strong>本政策更新于2023年11⽉1⽇，并于2023年11⽉1⽇发布并正式⽣效。</strong>
          <p>本隐私政策主要包含以下内容：</p>
          <p>⼀、个⼈信息的定义与范围</p>
          <p>二、我们如何收集您的信息</p>
          <p>三、Cookies及同类技术的使用</p>
          <p>四、我们如何共享、转让、公开披露您的个人信息</p>
          <p>五、我们如何保护您的个人信息</p>
          <p>六、您如何管理您的个人信息</p>
          <p>七、我们如何处理未成年人的个人信息</p>
          <p>八、本政策的更新</p>
          <p>九、如何联系我们</p>
          <h3>一、个人信息的定义与范围</h3>
          <p>（一）个人信息</p>
          <p>个⼈信息：指以电⼦或者其他⽅式记录的能够单独或者与其他信息结合识别特定⾃然⼈身份或者 反映特定⾃然⼈活动情况的各种信息。
          <strong>本政策中可能涉及到的个⼈信息包括但不限于：个⼈基本 信息（包括姓名、电话号码、性别、住址、⽣⽇等）；
            个⼈身份信息（包括身份证信息等）；⽹ 络身份标识信息（包括系统账号、IP地址、邮箱地址及与前述有关的密码、⼝令、⼝令保护答案）；
            个⼈财产信息（包括银⾏账号、交易和消费记录及虚拟财产信息等）；个⼈上⽹记录（包 括⽹站浏览记录、点击记录等）；
            个⼈设备信息（硬件型号、设备硬件参数、操作系统类型和基 本信息、MAC地址、
            移动设备识别码（IMEI）、SDCard、SIM卡信息等在内的个⼈常⽤设备信 息）；个⼈位置信息等。</strong>
          </p>
          <p>（二）个人敏感信息</p>
          <p>指⼀旦泄露、⾮法提供或滥⽤可能危害⼈身和财产安全，极易导致个⼈名誉、身⼼健康受到损害 或歧视性待遇等的个⼈信息。
            在本政策中可能涉及到的个⼈敏感信息包括：个⼈身份认证信息、 个⼈财产信息及其他信息（位置信息、通讯录信息等）。</p>
          <h3>二、我们如何收集您的信息</h3>
          <p>（⼀）在您使⽤我们的产品/服务时，您需要/可以选择授权我们收集和使⽤的个⼈信息包括：</p>
          <p>1、设备信息：我们会根据您在软件安装及使⽤中授权的具体权限，接受并记录您所使⽤的设 备相关信息（
            如MAC地址、设备型号、操作系统版本、设备设置、唯⼀设备识别符、设备环境等 软硬件特征信息）、
            设备所在位置相关信息（如IP地址、GPS位置以及能够提供相关信息的WLAN 接⼊点、蓝⽛和基站等传感器信息）
            及您所授权的设备权限使⽤所获信息。如您在安装及/或使⽤ 过程中拒绝授予我们相应权限，我们并不记录相应信息。</p>
          <p>2、服务⽇志信息：当您使⽤我们的⽹站或客户端提供的产品或服务时，我们会⾃动收集您对 我们服务的详细使⽤情况，作为有关⽹络⽇志保存。</p>
          <p>3、学业相关信息：当您注册成为“峰学未来”用户或购买、使用我们的产品或服务时，
            我们会获取您提供的包括但不限于角色身份（包括但不限于学生、家长、教师等）、高考年份、高考省份、
            首选科目、次选科目、成绩位次意向专业、目标院校、正式和模拟的高考志愿表等学业相关信息。</p>
          <p>4、个人身份信息：当您在购买我们的产品或服务时，对于需要签订服务协议的项目，
            我们会获取您您主动填写的购买学生及监护人的真实姓名、联系方式、身份证号码、住址等个人身份信息。</p>
          <p>5、当您与我们联系时，为验证您的身份，帮助您解决问题，我们可能会记录您与我们的对话，并收集其他需要解决问题所需要的必要信息。</p>
          <p>（二）、我们收集和使用个人信息的场景：</p>
          <p>1、帮助您成为“峰学未来”的⽤户</p>
          <p>为⽅便您使⽤我们的产品或服务，您需要⾸先成为我们的注册⽤户，以便我们为您提供服务，
            您需要提供注册、登陆峰学未来账号使⽤的电话号码，⽤户⾃⾏填写的昵称或姓名、⽤户⾃⾏上传的头像，并创建峰学未来⽤户的账户和密码。</p>
          <strong>在您使⽤身份认证的功能时，根据相关法律法规，您可能需要提供您的真实身份信息（真实 姓名、电话号码）以完成实名验证。
            这些信息属于个⼈敏感信息，您可以拒绝提供。如果拒绝提 供您将可能⽆法购买相关课程，但不影响其他功能的正常使⽤。</strong>
          <p>2、向您提供产品或服务</p>
          <p>2.1、当您使⽤我们提供的服务时，我们可能会记录⽤户操作的相关信息，以便优化峰学未来 为您提供更好的服务。您对此予以理解并同意。</p>
          <p>2.2、当您选择参加我们的促销等活动时，根据活动需要可能使⽤到您提供个⼈信息与第三⽅⽀付服务账号。
          <strong>这些信息可能包括个⼈敏感信息（个⼈电话号码、准考证号、居住地址、⽀付宝 账号、银⾏账号），
            是您收到转账或者礼品必要的。如果您拒绝提供这些信息，我们将可能⽆法 向您转账或发放礼品。</strong></p>
          <p>2.3、我们的客服和服务⽼师等售后功能会使⽤您的账号信息为您提供咨询服务。</p>
          <p>当您与我们联系时，我们可能会保存您的通信或通话记录和内容或您留下的联系⽅式，
            以便帮助您解决问题，或记录相关问题的处理⽅案及结果。我们的客服可能会使⽤您的账号信息与您核验您的身份。
            您有可能会在与我们的客服⼈员沟通时，提供上述信息外的其他信息。</p>
          <p>2.4、业务功能</p>
          <p>2.4.1、注册、登录</p>
          <p>A、当您注册、登录峰学未来及相关服务时，您可以通过⼿机号创建账户，并且您可以完善相关的⽹络身份识别信息（头像、姓名/昵称、性别、密码），
            收集这些信息是为了帮助您完成注册。如果您仅需要浏览、搜索服务，您不需要注册成为我们的账号及提供前述信息。</p>
          <strong>B、基于我们与通信运营商的合作，当您使⽤电话号码登录账户时，
            运营商会将您的⼿机号码发送给我们，便于我们为您提供快捷的登录服务。
            ⼿机号码属于个⼈敏感信息，如果拒绝提供将 ⽆法使⽤电话号码⽅式注册登录，
            但不影响您通过其他⽅式注册登录，也不影响其他功能的正常使⽤。</strong>
          <p>2.4.2、购买</p>
          <p>A、您在使⽤峰学未来APP或其他峰学未来平台购买课程产品时，您需要提供联系⼈姓名、收货地址、联系⽅式等，以便我们向您邮寄相应书籍及物资。</p>
          <p>B、您在⽀付时，您可以选择与峰学未来合作的第三⽅⽀付机构（如⽀付宝、微信⽀付、度⼩满⾦融、京东⽩条等⽀付通道）
            所提供的⽀付服务。⽀付功能本身并不收集您的个⼈信息，但我们需要将您的订单信息及对账信息与这些⽀付机构共享以确认您的⽀付指令并完成⽀付。</p>
          <p>C、峰学未来实物商品系第三⽅配送，我们为了顺利、安全、准确完成货物的交付及配送，
            第三⽅配送公司在发货及配送环节不可避免地获知相关配送信息，我们会严格要求第三⽅配送公司对⽤户的个⼈信息保密，
            只以配送之⽬的获悉和使⽤，不得对外泄露或做其他⽤途。</p>
          <p>2.4.3课程管理</p>
          <strong>在您通过并使⽤“峰学未来”学习平台产品及服务进⾏观看已购买的课程的直播和录播视频、下载课程视频、发表评论留⾔、
            在答疑区进⾏提问、使⽤题库服务等操作时，我们可能会获取您的⻨克⻛、摄像头、视频、照⽚、录⾳、位置、⽇历权限，
            可能收集您发布的信息并展示您的头 像、昵称和发布内容等。</strong>
          <p>2.4.4日志记录</p>
          <strong>当您使⽤“峰学未来”学习平台产品及服务时，我们会记录您的操作⽇志，⽇志信息包括：
            您操作、使⽤的⾏为信息：点击、关注、收藏、搜索、浏览、分享；您主动提供的信息：反馈、发布、点赞（喜欢）、评论等。</strong>
          <p>2.4.5搜索</p>
          <p>您使⽤“峰学未来”学习平台产品及服务进⾏搜索操作时，我们会收集您的搜索关键字信息、 ⽇志记录。
            为了提供⾼效的搜索服务，部分前述信息会暂时存储在您的本地存储设备之中，并可 向您展示搜索结果内容、搜索历史记录。</p>
          <p>2.4.6分享与支付</p>
          <p>在您通过峰学未来APP将您感兴趣的内容分享⾄例如微信、QQ等时，或使⽤微信、QQ等⽀ 付功能时，我们会访问您的软件安装列表，
            以检测您是否安装了相应的客户端⼝。</p>
          <p>2.5 当您购买或使用我们提供的产品或服务时，您需要提供包括但不限于用户自行填写的角色身份（包括但不限于学生、家长、教师等）、
            高考年份、高考省份、首选科目、次选科目、成绩位次、意向专业、目标院校、正式和模拟的高考志愿填报表等学业相关信息。
            我们将根据以及以上信息来为您提供更好的服务。
            以上您主动填报的信息有可能作为数据源的一部分帮助我们更好的建立或优化高考志愿填报大数据模型。</p>
          <p>3、与您联系或发送广告</p>
          <p>我们为满⾜您的需求，可能通过您提供的信息与您联系。我们可能会定期或不定期向您发送 有关产品、服务或相关活动的信息。</p>
          <p>（三）为您提供安全保护保障</p>
          <p>您的⽹络身份识别信息帮助您维护软件正常使⽤及使⽤安全。我们将通过弹出窗⼝询问您是否可以获取相应权限，
            只有您选择同意后，我们才会为您开启相应权限并接受您的个⼈信息。</p>
          <p>（四）征得授权同意的例外</p>
          <p>根据相关法律法规规定及国家标准，以下情形中，我们可能会依法收集并使⽤您的个⼈信息⽆需征得您的同意：</p>
          <p>（1）与国家安全、国防安全直接相关的；</p>
          <p>（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p>（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
          <p>（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
          <p>（5）所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
          <p>（6）从合法公开披露的信息中收集的您的个⼈信息的，如合法的新闻报道、政府信息公开等渠道；</p>
          <p>（7）根据您的要求签订合同所必需的；</p>
          <p>（8）⽤于维护所提供的产品与/或服务的安全稳定运⾏所必需的，例如发现、处置产品与/或 服务的故障；</p>
          <p>（9）为合法的新闻报道所必需的；</p>
          <p>（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述 的结果时，
            对结果中所包含的个⼈信息进⾏去标识化处理的；</p>
          <p>（11）法律法规规定的其他情形。</p>
          <h3>三、Cookies及同类技术的使用</h3>
          <p>（一）Cookies的使用</p>
          <p>1、为了实现您获得更轻松的访问体验。我们可能通过Cookies或同类技术收集您的设备型号、
            操作系统、唯⼀设备标识符、登录IP地址信息、以及缓存您的浏览信息、点击信息。
            我们向您发送 Cookies是为了简化您重复登录的步骤实现登录时⽆需重复输⼊⽤户名及密码信息，并帮助判断您 的登录状态以及账户或数据安全。</p>
          <p>2、我们不会将Cookies⽤于本隐私政策所述⽬的之外的任何⽤途。 您可根据⾃⼰的偏好管理或删 除Cookies。
            但如果您这么做，您可能需要在每⼀次访问峰学未来⽹站时亲⾃更改⽤户设置，
            您之前所记录的相应信息也均会被删除，并且可能会对您所使⽤服务的安全性有⼀定影响。</p>
          <p>（二）⽹络Beacon和同类技术的使⽤</p>
          <p>除Cookies外，我们还会在⽹站上使⽤⽹络Beacon等其他同类技术。
            我们的⽹⻚上常会包含⼀些 电⼦图像（称为"单像素"GIF⽂件或"⽹络Beacon"）。</p>
          <p>我们使⽤⽹络Beacon的⽅式有：</p>
          <p>1、通过在峰学未来⽹站上使⽤⽹络Beacon，计算⽤户访问数量，并通过访问Cookies辨认注册的 峰学未来⽤户。</p>
          <h3>四、我们如何共享、转让、公开披露您的个⼈信息</h3>
          <p>1、共享</p>
          <p>我们不会向其他任何公司、组织和个⼈分享您的个⼈信息，但以下情况除外：</p>
          <p>（1）在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他⽅共享您的个⼈信息。</p>
          <p>（2）我们可能根据法律法规规定，或政府主管部⻔的强制性要求，对外共享您的个⼈信息。</p>
          <p>（3）与授权合作伙伴共享：我们将审慎评估第三⽅使⽤共享信息的⽬的，对这些合作⽅的安全保障能⼒进⾏综合评估，
            并要求其遵循合作法律协议。我们会对合作⽅获取信息的软件⼯具开 发包（SDK）、应⽤程序接⼝（API）进⾏严格的安全检测，以保护数据安全。
            对我们会要求他们 按照我们的说明、本隐私服务政策以及其他任何相关的保密和安全措施来处理个⼈信息。</p>
          <p>峰学未来APP接入第三方SDK清单：</p>
          <strong>a. 极光推送</strong>
          <p>目的：给用户推送消息</p>
          <p>官网地址：
            <a href="https://www.jiguang.cn/push?source=bdpc&plan=1&unit=2&keyword=5">
              https://www.jiguang.cn/push?source=bdpc&plan=1&unit=2&keyword=5
            </a>
          </p>
          <p>收集个人信息类型：收集您的设备相关信息（如IMEI号，SerialNumber，IMSI，UserID，AndroidID，MEID，Google AdvertisingID，
            手机Region设置，设备型号，手机电量，手机操作系统版本及语言）、
            使用推送服务的应用信息（如APP包名及版本号，运行状态）、推送SDK版本号、网络相关信息（如IP或域名连接结果，当前网络类型）、
            消息发送结果，通知栏状态（如通知栏权限、用户点击行为），锁屏状态（如是否锁屏，是否允许锁屏通知）。</p>
          <strong>b. 移动安全联盟（含华为推送）</strong>
          <p>目的：统一多厂商的设备标识</p>
          <p>官网地址：
            <a href="http://www.msa-alliance.cn/">
              http://www.msa-alliance.cn/
            </a>
          </p>
          <p>收集个人信息类型：“AAID（应用匿名标识）、Token、OAID、Topic订阅关系，如果您选择了数据存储地，
            则按照您选择的数据存储地进行数据存储；否则以上信息将不被存储。消息下发记录、Token申请记录、显示/点击/关闭打点上报记录，
            需要您开启华为分析能力并且选择数据存储地，才会进行数据存储，否则不进行数据存储。
            缓存消息内容，根据客户端所在的大区进行数据存储。如果您的应用推送消息时，启用了基于华为账号的消息校验功能，
            将在该场景下收集手机用户的标识符HMSCoreopenld，HMScoreopenld将进行不可逆加密仅保存在设备端侧。”</p>
          <strong>c. 神策统计：</strong>
          <p>目的：统计用户信息，分析用户行为</p>
          <p>官网地址：
            <a href="https://www.sensorsdata.cn/auto?utm_source=baidusem&utm_medium=cpc&utm_term=%E7%A5%9E%E7%AD%96&utm_content=%E5%93%81%E7%89%8C%5F%E5%93%81%E7%89%8C%5F%E7%A5%9E%E7%AD%96&utm_campaign=%E5%93%81%E7%89%8C%E7%B2%BE%E7%A1%AE%5FE&account=exact">
              https://www.sensorsdata.cn/auto?utm_source=baidusem&utm_medium=cpc&utm_term=%E7%A5%9E%E7%AD%96&utm_content=%E5%93%81%E7%89%8C%5F%E5%93%81%E7%89%8C%5F%E7%A5%9E%E7%AD%96&utm_campaign=%E5%93%81%E7%89%8C%E7%B2%BE%E7%A1%AE%5FE&account=exact
            </a>
          </p>
          <p>收集个人信息类型：收集您的IMEI、MAC地址、AndroidID、IDFA、读取SDCard数据、联网信息</p>
          <strong>d. 度小满金融;度小满钱包（含百度广告、百度推送）：</strong>
          <p>目的：教育类分期支付</p>
          <p>官网地址：
            <a href="https://www.duxiaoman.com/index">
              https://www.duxiaoman.com/index
            </a>
          </p>
          <p>收集个人信息类型：支付授权信息、相机权限、Mac地址、定位权限、Android_id、IMSI</p>
          <strong>e.阿里云日志</strong>
          <p>目的：上报用户行为日志</p>
          <p>官网地址：
            <a href="https://www.aliyun.com/product/sls?utm_content=se_1009280978">
              https://www.aliyun.com/product/sls?utm_content=se_1009280978
            </a>
          </p>
          <p>收集个人信息类型：设备MAC地址、唯一设备识别码（IMEI/androidID/IDFA/OPENUDID/GUID、SIM卡IMSI信息）</p>
          <strong>f.阿里云号码认证</strong>
          <p>目的：一键登录</p>
          <p>官网地址：
            <a href="https://help.aliyun.com/document_detail/121113.html?spm=a2c4g.11174283.6.560.51de4c07pSYKwH">
              https://help.aliyun.com/document_detail/121113.html?spm=a2c4g.11174283.6.560.51de4c07pSYKwH
            </a>
          </p>
          <p>收集个人信息类型：网络类型、网络地址、运营商类型、本机号码用于一键获取的手机号码；
            使用国际移动用户识别号码和SIM卡数量识别卡状态；使用收集设备类型、手机操作系统</p>
          <strong>g.快商通</strong>
          <p>目的：客服咨询</p>
          <p>官网地址：
            <a href="https://www.kuaishang.cn/">
              https://www.kuaishang.cn/
            </a>
          </p>
          <p>收集个人信息类型：会调取用户的网络权限、获取网络状态权限、获取wifi状态权限、获取设备</p>
          <strong>h.百度统计</strong>
          <p>目的：手机用户在应用内的使用行为及数据，用于开发者根据使用数据评估软件效果，不断优化功能提升用户体验</p>
          <p>官网地址：
            <a href="https://mtj.baidu.com">
              https://mtj.baidu.com
            </a>
          </p>
          <p>收集个人信息类型：设备信息</p>
          <strong>i.网易;七鱼</strong>
          <p>目的：用于为用户提供在线的客服咨询服务，提供多渠道的信息沟通。</p>
          <p>官网地址：
            <a href="https://b.163.com/home/qiyu/onlinekefu">
              https://b.163.com/home/qiyu/onlinekefu
            </a>
          </p>
          <p>收集个人信息类型：麦克风、相机、照片读取权限</p>
          <strong>j.声网</strong>
          <p>目的：提供直播间内的在线互动、聊天的功能</p>
          <p>官网地址：
            <a href="https://docs.agora.io/cn/All/API%20Reference/ios_ng/API/rtc_api_overview_ng.html">
              https://docs.agora.io/cn/All/API%20Reference/ios_ng/API/rtc_api_overview_ng.html
            </a>
          </p>
          <p>收集个人信息类型：日志信息（登录账号、IP地址、电信运营商、网络环境、访问日期和时间、停留时长）、
            设备信息（Serial、SIM卡IMSI识别码、设备机型、操作系统及版本、客户端版本、设备分辨率、包名、唯一设备标识符、软硬件特征信息）</p>
          <strong>k.新浪微博开放平台</strong>
          <p>目的：帮助用户分享内容至第三方应用</p>
          <p>官网地址：
            <a href="https://open.weibo.com/">
              https://open.weibo.com/
            </a>
          </p>
          <p>收集个人信息类型：设备识别信息</p>
          <strong>l.腾讯浏览服务；TBS;腾讯X5浏览器</strong>
          <p>目的：在线浏览导出的文件</p>
          <p>官网地址：
            <a href="https://x5.tencent.com/">
              https://x5.tencent.com/
            </a>
          </p>
          <p>收集个人信息类型：获取IMSI、Android_ID</p>
          <strong>m.Bugly SDK</strong>
          <p>目的：为移动开发者提供专业的异常上报和运营统计，帮助开发者快速发现并解决异常，同时掌握产品运营动态，及时跟进用户反馈；</p>
          <p>官网地址：
            <a href="https://bugly.qq.com/v2/index">
              https://bugly.qq.com/v2/index
            </a>
          </p>
          <p>收集个人信息类型：日志信息（包括：第三方开发者自定义日志、Logcat 日志以及 APP 崩溃堆栈信息）、
            设备 ID（包括：Android_ID 以及idfv）、联网信息、系统名称、系统版本以及国家码</p>
          <strong>n.京东支付</strong>
          <p>目的：接入京东支付SDK，支持京东支付</p>
          <p>官网地址：
            <a href="https://jdpay.com/home/">
              https://jdpay.com/home/
            </a>
          </p>
          <p>收集个人信息类型：设备识别信息</p>
          <strong>o.微信开放平台</strong>
          <p>目的：支持微信授权登录、微信分享和微信支付</p>
          <p>官网地址：
            <a href="https://open.weixin.qq.com/">
              https://open.weixin.qq.com/
            </a>
          </p>
          <p>收集个人信息类型：设备识别信息</p>
          <strong>p.支付宝</strong>
          <p>目的：您在购买平台课程或服务时，为方便您完成相关支付行为</p>
          <p>官网地址：
            <a href="https://open.alipay.com/">
              https://open.alipay.com/
            </a>
          </p>
          <p>收集个人信息类型：电话、录音、读取本地文件、向本地写文件、相机、共享文件临时访问权限、读取和写入系统剪切板、
            获取WIFI的MAC地址、获取WIFI的SSID、获取WIFI的BSSID、获取设备IMEI、Android ID等设备识别信息</p>
          <strong>q.研途</strong>
          <p>目的：统计用户信息，分析用户行为，个性化推荐适合的考研等服务产品。</p>
          <p>官网地址：
            <a href="https://www.kaoyanvip.cn/">
              https://www.kaoyanvip.cn/
            </a>
          </p>
          <p>收集个人信息类型：用户主动填写的学业相关信息及联系方式。</p>
          <strong>r.友盟统计分析SDK</strong>
          <p>目的：进行APP运营统计与分析</p>
          <p>官网地址：
            <a href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a>
          </p>
          <p>收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息</p>
          <p>数据发送频率：APP启动时发送当次启动数据和上次的使用时长等缓存数据，当次使用过程中产生的自定义事件数据缓存在客户端，下次启动时发送。</p>
          <strong>s.中移互联网移动认证</strong>
          <p>目的：识别用户的手机号码快速登录，以及查询、分析和风险控制</p>
          <p>官网地址：
            <a href="https://wap.cmpassport.com/resources/html/contract.html">https://wap.cmpassport.com/resources/html/contract.html</a>
          </p>
          <p>收集个人信息类型：网络类型、网络地址、运营商类型、本机号码信息、SIM卡状态、手机设备类型、手机操作系统、硬件厂商。</p>
          <strong>t.中国联通手机号一键登录</strong>
          <p>目的：识别用户的手机号码快速登录，以及实现业务风控</p>
          <p>官网地址：
            <a href="https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?spm=a2c4g.11186623.0.0.41f1633eHxMLkQ&fromsdk=true">https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?spm=a2c4g.11186623.0.0.41f1633eHxMLkQ&fromsdk=true</a>
          </p>
          <p>收集个人信息类型：网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商。</p>
          <strong>u.天翼账号认证SDK</strong>
          <p>目的：识别用户的手机号码快速登录，以及实现业务风控</p>
          <p>官网地址：
            <a href="https://e.189.cn/sdk/agreement/detail.do?appKey=E_189&hidetop=true&returnUrl=">https://e.189.cn/sdk/agreement/detail.do?appKey=E_189&hidetop=true&returnUrl=</a>
          </p>
          <p>收集个人信息类型：注册手机号码、本机号码、网络连接类型、网络状态信息、网络地址、运营商类型、手机设备类型、手机设备厂商、手机操作系统类型及版本。</p>
          <p>（4）实现功能或服务的共享信息</p>
          <p>A. 当您在使⽤峰学未来APP中由我们的关联⽅、第三⽅提供的功能，或者当软件服务提供 商、智能设备提供商、系统服务商、智能设备提供商、
            系统服务提供商与我们联合为您提供服务时我们会将实现业务所必须的信息与这些关联⽅、第三⽅共享，
            ⽤于综合统计并通过算法做特征 与偏好分析，形成间接⼈群画像。</p>
          <p>B. ⼩程序：当您使⽤⼩程序时，未经您同意，我们不会向这些开发者、运营者共享您的个⼈信息。
            当您使⽤⼩程序时，⼩程序可能会使⽤您授权的相关系统权限，您可以在⼩程序中撤回授权。</p>
          <p>C. ⽀付功能：⽀付功能由与我们合作的第三⽅⽀付机构向您提供服务。第三⽅⽀付机构可能 需要收集您的姓名、银⾏卡类型及卡号、有效期及⼿机号码。
            银⾏卡号、有效期及⼿机号码是个⼈敏感信息，这些信息是⽀付功能所必需的信息，拒绝提供将导致您⽆法使⽤该功能，但不影响 其他功能的正常使⽤。</p>
          <p>（5）实现安全与分析统计的共享信息</p>
          <p>A.保障使⽤安全；我们⾮常重视账号、服务及内容安全，为保障您和其他⽤户的账号与财产安全，
            使您和我们的正当合法权益免受不法侵害，我们和关联⽅或服务提供商可能共享必要的设备、账号及⽇志信息。</p>
          <p>B.分析产品使⽤情况：为分析我们服务的使⽤情况，提升⽤户使⽤的体验，
            可能与关联⽅或第三⽅共享产品使⽤情况（奔溃、闪退）的统计性数据，这些数据难以与其他信息结合识别您的个⼈身份。</p>
          <p>2、转让</p>
          <p>根据法律规定及合理商业习惯，在我们计划与其他公司合并或被其收购或进⾏其他资本市场活动时，
            以及其他情形下我们需要接受来⾃其他主体的尽职调查时，我们会把您的信息提供给必要的主体，
            但我们会通过和这些主体签署保密协议等⽅式要求其对您的个⼈信息采取合理的保密措施。
            随着我们业务的发展，我们及我们的关联⽅有可能进⾏合并、收购、资产转让或类似的交易，您的个⼈信息有可能作为此类交易的⼀部分⽽被转移。</p>
          <p>3、公开披露</p>
          <p>我们仅会在以下情形且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个⼈信息：</p>
          <strong>（1）根据您的需求，在您明确同意的披露⽅式下披露您所指定的个⼈信息。</strong>
          <strong>（2）为维护我们及关联⽅或其他⽤户的合法权益，在协助处理与您有关的交易纠纷或争议时，
            我们可能向您的交易相对⽅或存在利害关系的第三⽅提供解决交易纠纷或争议所必需的信息。</strong>
          <strong>（3）根据法律规定，刑事侦查机关为调查犯罪，依法定程序调取的必要个⼈信息；或⾏政机关、司法机构，依法定程序并经您授权同意调取的必要个⼈信息，
            我们会向其提供您的相关信息；⾮经法定程序或未获得您的同意，我们不会将您的个⼈信息提供给任何第三⽅机构或个⼈。
          </strong>
          <h3>五、我们如何保护您的个人信息</h3>
          <p>（一）我们已使⽤符合业界标准的安全防护措施保护您提供的个⼈信息，
            防⽌数据遭到未经授权访问、公开披露、使⽤、修改、损坏或丢失。我们会采取⼀切合理可⾏的措施，保护您的个⼈信息。</p>
          <p>（二）我们会采取⼀切合理可⾏的措施，确保未收集⽆关的个⼈信息。
            我们只会在达成政策所述 ⽬的所需的期限内保留您的个⼈信息，除⾮需要延⻓保留期或受到法律的允许。</p>
          <strong>（三）互联⽹并⾮绝对安全的环境，我们强烈建议您通过安全⽅式、使⽤复杂密码，协助我们保证您的账号安全。
            如您发现⾃⼰的个⼈信息泄密，尤其是您的账户或密码发⽣泄漏，请您⽴即根据本政策中提供的联系⽅式联络我们，以便我们采取相应措施。</strong>
          <p>（四）互联⽹环境并⾮百分之百安全，我们将尽⼒确保或担保您发送给我们的任何信息的安全性。
            在不幸发⽣个⼈信息安全事件后，我们将按照法律法规的要求，及时向您告知：
            安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可⾃主防范和降低⻛险的建议、对您的补救措施等。
            我们将及时将事件相关情况以⽹站窗⼝提示、APP推送通知、发送邮件/短消 息、电话等⽅式告知您。
            难以逐⼀告知个⼈信息主体时，我们会采取合理、有效的⽅式发布公 告。同时，我们还将按照监管部⻔要求，主动上报个⼈信息安全事件的处置情况。</p>
          <h3>六、您如何管理您的个人信息</h3>
          <p>根据适⽤的法律法规，我们将采取适当的技术⼿段保障您对⾃⼰的个⼈信息⾏使以下权利：</p>
          <p>（一）访问您的个人信息</p>
          <p>您有权访问峰学未来APP中您绑定学员信息及其与绑定学员关联的课程信息、订单信息、⽀付信息。当您通过账号登录峰学未来APP后，
            在“我的”功能⻚⾯下即可访问我们保留您绑定的学员信 息及订单信息。</p>
          <p>（二）更正您的个人信息</p>
          <p>您可在峰学未来APP的账户内，修改您的学员信息的头像设定头像信息、昵称、性别。
          您还可以通过联系我们对峰学未来APP绑定的学⽣姓名、家庭地址及注册电话、
            与本账号所有者关系进⾏修改，您还可以要求我们对错误或不完整的信息做出更正或更新。</p>
          <p>（三）删除您的个人信息</p>
          <p>当您不再使⽤我们的产品或服务，或我们违反法律法规或与您的约定收集、使⽤、与他⼈分享您的个⼈信息时，您有权删除您提供的信息。
            您可与我们联系，提交删除申请。在满⾜本政策要求及法律法规要求的最短保存期限的情况下，
            我们将对您的个⼈信息进⾏删除或匿名化处理，但这样可能导致我们⽆法向您提供相应的服务。</p>
          <p>（四）注销您的账户</p>
          <p>您有权注销您的峰学未来账户，您可以通过访问我们APP⻚⾯上的“我的”---“安全设置”---“注 销账号”中进⾏在线操作。
            有关注销账户的相关规则和流程，请参⻅《账户注销须知》。
          <strong>您注销成 功后，我们将停⽌为您提供产品或服务，并根据法律法规的要求尽快删除您的个⼈信息或作匿名化处理。但在特定情形下，
            如合理必要地履⾏我们的法律义务、解决争议、防⽌欺诈与滥⽤，我们将在使⽤者账号注销后保留不可识别个⼈的信息。</strong>
          </p>
          <p>（五）改变您授权同意的范围</p>
          <p>如您想更改相关功能的授权范围（例如相机、⻨克⻛、通知、⽇历等），您可以通过您的硬件设备修改个⼈设置。
            当您收回同意后，我们将不再处理相应的个⼈信息。但当您收回同意的决定， 不会影响此前基于您的授权⽽开展的个⼈信息处理。</p>
          <p>（六）响应您的上述请求</p>
          <p>为保障安全，你可能需要提供书⾯请求，或以其他⽅式证明你的身份。我们可能会先要求你验证 ⾃⼰的身份，然后再处理你的请求。
            我们将在⼗五个⼯作⽇内做出答复。对于你合理的请求，我 们原则上不收取费⽤，但<strong>对那些⽆端重复、
              需要过多技术⼿段(需要开发新系统或从根本上改变现 ⾏惯例)、
              给他⼈合法权益带来⻛险或者⾮常不切实际(例如：涉及备份磁带上存放的信息)的请 求，我们可能会予以拒绝。</strong></p>
          <p>在以下情形中，我们将无法响应您的请求：</p>
          <p>（1）与个人信息控制者履行法律法规规定的义务相关的。</p>
          <p>（2）与国家安全、国防安全直接相关的。</p>
          <p>（3）与公共安全、公共卫生、重大公共利益直接相关的。</p>
          <p>（4）与刑事侦查、起诉、审判和执行判决这样直接相关的。</p>
          <p>（5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的。</p>
          <p>（6）出于维护个人信息主体或其他个人的生命、财产这样重大合法权益但又很难得到本人同意的。</p>
          <p>（7）响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的。</p>
          <p>（8）涉及商业秘密的。</p>
          <h3>七、我们如何处理未成年人的个人信息</h3>
          <p>我们的产品、⽹站和服务主要⾯向成年⼈。如您为未成年⼈的，建议您请您的⽗⺟或监护⼈仔细阅读本隐私政策，并在征得您的⽗⺟或监护⼈
            同意的前提下使⽤我们的服务或向我们提供信息。
            对于经服务同意⽽收集⼉童个⼈信息的情况，我们只会在受到法律允许、⽗⺟或监护⼈明确同意或保护⼉童所必要的情况下使⽤或公开披露此信息。
            如果我们发现⾃⼰在未事先获得可证实 的⽗⺟同意的情况下收集了⼉童的个⼈信息，则会设法尽快删除相关数据。</p>
          <h3>八、本政策的更新</h3>
          <p>我们可能会对隐私政策进⾏修改或调整，如修改或调整的，我们将在新版隐私政策正式⽣效前，
            将新政策公布在我们的APP或⽹站上，⽅便您了解具体变化并向我们提出建议，
            经调整或变更的内容⼀经公布后的7⽇后⽣效。如果您继续使⽤我们的服务即被视为对新版隐私协议的接受。</p>
          <h3>十一、 联系我们</h3>
          <p>您可以通过以下方式与我们联系：</p>
          <p>1、您可以寄信到如下地址：</p>
          <p>公司名称：苏州峰学未来教育科技有限公司</p>
          <p>地址：江苏省苏州市工业园区星湖街328号创意产业园6幢403</p>
          <p>2、您可以通过峰学未来网站/APP上提供的在线联系客服系统与我们联系；</p>
          <div class="sig con-part">
            <p>苏州峰学未来科技有限公司</p>
            <p>2023年11月1日</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--<someComponent></someComponent>-->
</template>

<script>
//import someComponent from './someComponent'
export default {
  name: "",
  data() {
    return {
      msg: ""
    }
  },
  component: {
    //someComponent
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.fxwljy.com/attach/file1706509868982.otf');
}
.policy-details{
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  margin-top: 78px;
  background-color: #F5F7FA;
  .policy-title{
    width: 1200px;
    margin: 0 auto;
    ::v-deep .el-breadcrumb__inner.is-link{
      font-size: 14px;
      font-family: 'SourceHanSansCN Microsoft YaHei';
      font-weight: 400;
      color: #909295;
    }
    span{
      display: inline-block;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      font-family: 'SourceHanSansCN Microsoft YaHei';
      font-weight: 400;
      color: #909295;
    }
  }
  .policy-content{
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 4px;
    margin-bottom: 160px;
    .main-content{
      padding: 68px 48px;
      .title-content {
        width: 100%;
        border-bottom: 1px solid rgba(219, 221, 224, 0.5);
        padding-bottom: 20px;
        .details-title{
          width: 100%;
          h2{
            font-size: 30px;
            font-family: 'SourceHanSansCN Microsoft YaHei';
            font-weight: bold;
            color: #0A0D0F;
            line-height: 45px;
          }
        }
      }
      .details-content {
        width: 100%;
        padding: 0;
        margin-top: 48px;
        p{
          font-size: 16px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #0A0D0F;
          line-height: 32px;
          letter-spacing: 1px;
          margin-bottom: 20px;
          /*text-align: justify;*/
          strong{
            display: inline;
          }
          a{
            word-wrap: break-word;
            color: #0A0D0F;
          }
        }
        strong{
          font-size: 16px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          color: #0A0D0F;
          line-height: 32px;
          letter-spacing: 1px;
          margin-bottom: 20px;
          display: inline-block;
          text-align: justify;
        }
        h3{
          font-size: 20px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: bold;
          color: #0A0D0F;
          line-height: 30px;
          margin-bottom: 20px;
          margin-top: 50px;
        }
        .con-part{
          margin-top: 50px;
          text-align: right;
          p{
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>